module.exports = __webpack_public_path__ + "media/images/icon-insta-359d7d3f391888ab26c855bd50b5e657.svg";